import {
    Box,
    Flex,
    Heading,
    HStack,
    VStack,
    Button,
    Image,
    Input,
    InputGroup,
    InputLeftElement,
    Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { StoreFrontContainer } from '../components/LandingPageComponents/styles/HeaderStyles';
import { cartIcon, search, whiteCart } from './dashboard/components/Icons';
import basket from '../assets/Basket.svg';
import banner from '../assets/storebanner.png';
import { useNavigate } from 'react-router-dom';
import AddToCartModal from '../pages/dashboard/components/AddToCartModal';
// import { dummyList } from '../dummyData/dummyData';
import {  useSelector } from 'react-redux';

const StoreFront = () => {
    const navigate = useNavigate();
    const storeReducer = useSelector((state) => state.storeReducer);
    const { store } = storeReducer;
    const [isCartModalOpen, setIsCartModalOpen] = useState(false);
    const [seeall, setSeeall] = useState(false);
    const closeCartModal = () => setIsCartModalOpen(false);
    const openCartModal = () => setIsCartModalOpen(true);
    const addToCart = (item) => {
        openCartModal();
    };
    return (
        <StoreFrontContainer>
            <HStack justify="space-between" py="15px" px="20px" alignItems="center">
                <Text
                    display="flex"
                    alignItems="center"
                    color="#121212"
                    fontSize="24px"
                    fontWeight="700">
                    {`${store.name}` || `Ochije&apos;s`} StoreFront
                    <Image src={basket} w="30px" ml="10px" />
                </Text>
                <div
                    className="menuSection"
                    onClick={() => navigate('/cart/true', { replace: true })}>
                    {cartIcon}
                </div>
            </HStack>
            <InputGroup
                overflow="hidden"
                bg="#FFFFFF"
                border="0.3px solid #DEDEDE"
                borderRadius="8px"
                w="90%"
                mx="auto"
                h="40px"
                mb="30px">
                <InputLeftElement pl="10px" h="full" pointerEvents="none" pr="10px" opacity=".3">
                    {search}
                </InputLeftElement>
                <Input
                    type="text"
                    placeholder="Search"
                    h="full"
                    inputMode="search"
                    border="none"
                    fontSize="13px"
                    _placeholder={{ color: '#999999' }}
                />
            </InputGroup>
            {!seeall && (
                <Box w="90%" mx="auto">
                    <Image src={banner} w="full" />
                </Box>
            )}
            <Box w="90%" mx="auto" mt="10px" mb="15px">
                <HStack alignItems="center" justifyContent="space-between">
                    <Heading fontSize="18px">Popular</Heading>
                    {!seeall && (
                        <Flex alignItems="center" gap="8px">
                            <Text color="#1b3b5f" fontSize="12px" onClick={() => setSeeall(true)}>
                                See all{' '}
                            </Text>
                            {arrow}
                        </Flex>
                    )}
                </HStack>
            </Box>

            <HStack w="90%" mx="auto" gap="5%" alignItems="start" justifyContent="start">
                {store?.products?.items.map((item, id) => (
                    <Box
                        key={id}
                        w="45%"
                        pt="15px"
                        pb="10px"
                        boxShadow="0px 4px 50px -5px rgba(32, 32, 32, 0.1)"
                        borderRadius="8px"
                        mb="2rem">
                        <Box
                            margin="auto"
                            height="120px"
                            w="100%"
                            borderRadius="8px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            pos="relative"
                            mb="20px">
                            <Image src={item.image} w="90%" />
                            <Button
                                pos="absolute"
                                top="-.5rem"
                                right=".5rem"
                                h="25px"
                                bg="#0B59D5"
                                color="white"
                                borderRadius="200px"
                                fontWeight="400"
                                fontSize="10px"
                                size="sm"
                                onClick={() => addToCart(item)}>
                                + {whiteCart}
                            </Button>
                        </Box>
                        <VStack alignItems="start">
                            <Text
                                color="#AAAAAA"
                                lineHeight="20px"
                                mt="0"
                                textOverflow="ellipsis"
                                whiteSpace="nowrap"
                                w="95%"
                                overflow="hidden"
                                pl="12px"
                                pt="12px"
                                fontSize="12px"
                                fontWeight="400">
                                {item.prodName}
                            </Text>
                            <Text
                                color="#121212"
                                pl="12px"
                                pb="4px"
                                fontWeight="600"
                                mt="0"
                                fontSize="14px"
                                lineHeight="20px"
                                mb="12px">
                                ₦{item.price}
                            </Text>
                        </VStack>
                    </Box>
                ))}
            </HStack>
            <AddToCartModal
                isModalOpen={isCartModalOpen}
                closeModal={closeCartModal}
                setIsModalOpen={setIsCartModalOpen}
            />
        </StoreFrontContainer>
    );
};

export default StoreFront;
const arrow = (
    <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.8625 2.65749C11.8624 2.65735 11.8623 2.65718 11.8621 2.65703L9.41278 0.140902C9.22928 -0.0475903 8.9325 -0.0468889 8.74985 0.142547C8.56722 0.331958 8.56793 0.638321 8.75142 0.826837L10.3959 2.51613H0.46875C0.209859 2.51613 0 2.73276 0 3C0 3.26724 0.209859 3.48387 0.46875 3.48387H10.3959L8.75144 5.17316C8.56795 5.36168 8.56725 5.66804 8.74987 5.85745C8.93252 6.04691 9.22933 6.04757 9.4128 5.8591L11.8621 3.34297C11.8623 3.34282 11.8624 3.34265 11.8625 3.34251C12.0461 3.15336 12.0455 2.84601 11.8625 2.65749Z"
            fill="#1b3b5f"
        />
    </svg>
);
